import React from 'react';

import { TshirtTeam } from '@/components/TshirtTeam';
import {
  parseParamsTshirtAndShield,
  tshirtKeys,
} from '@/modules/edit-my-account/functions/utils';
import { initialTshitAndShield } from '@/store/tshirtAndShield';
import { DatosParticipanteMiniLigasTO } from '@/types/minileagues';
import { cn } from '@/utils';

export const SubItemFixture = React.memo(
  ({
    item,
    score,
    local,
  }: {
    item: DatosParticipanteMiniLigasTO;
    local?: boolean;
    score?: number;
  }) => {
    const scoreText = () => {
      if (score === undefined) return;
      return `${score} ${score === 1 ? 'punto' : 'puntos'}`;
    };

    const tshirt = parseParamsTshirtAndShield(
      item.camiSvg,
      tshirtKeys,
      initialTshitAndShield.tshirt
    );

    const Participant = ({ local }: { local?: boolean }) => {
      return (
        <div
          className={cn('flex flex-1 items-center w-full', {
            'justify-start': local,
            'justify-end text-right': !local,
          })}
        >
          {/* Camiseta */}
          <div
            className={cn('w-9 flex-shrink-0', {
              'mr-3.5': local,
              'ml-3.5 order-2': !local,
            })}
            style={{
              alignSelf: 'flex-start',
            }}
          >
            <TshirtTeam
              id={item.id}
              tshirt={tshirt}
              withShield={
                JSON.stringify(tshirt) ===
                JSON.stringify(initialTshitAndShield.tshirt)
              }
            />
          </div>

          {/* Información del jugador */}
          <div
            className={cn('flex flex-col', {
              'order-1': !local, // para el visitante, el texto va antes en el DOM
            })}
          >
            <p className="font-bold text-gdt-gray lg:text-sm">
              {item.part?.n} {item.part?.a}
            </p>
            <p className="font-semibold text-3xs text-gdt-gray-2 lg:text-xs">
              {item.ne}
            </p>
            <span className="inline-block font-bold text-3xs text-gdt-status-green lg:text-sm">
              {scoreText()}
            </span>
          </div>
        </div>
      );
    };

    if (local) {
      return <Participant local={true} />;
    }

    return <Participant />;
  }
);

SubItemFixture.displayName = 'SubItemFixture';
